import Vue from "vue";
import Vuex from "vuex";
import Utils from "@/helpers/utils";
import querystring from 'querystring';
import axios from 'axios';

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        ui: {
            alert: {
                type: "",
                text: ""
            },
            window: {
                error: true,
                loaded: false,
                language: "el",
                theme: "light",
            },
            translations: {}
        },
        notifications: {
            unread: 1,
            read: 1,
        },
        user: {
            token: null,
            notifications: null,
            id: null,
            active: null,
            am: null,
            email: null,
            name: null,
            firstname: null,
            lastname: null,
            parentname: null,
            kind: null,
            lang: null,
            theme: null,
            gender: null,
            created_at: null,
            updated_at: null,
            remote_id: null
        },
        settings: {
            url: {
                app: 'https://thesis.iee.ihu.gr',
                api: 'https://api.thesis.iee.ihu.gr',

                //Sandbox
                // app: 'http://localhost:8080',
                // api: 'http://localhost:3000',
                login: null
            },
            thesis: {
                characterMinTitle: null,
                characterMaxTitle: null,
                characterMinAbstract: null,
                characterMaxAbstract: null,
                maxFileSize: null,
                status: null,
                grade: null
            },
            languages: [],
            themes: [],
            version: null
        }
    },
    mutations: {
        token(state, data) {
            state.user.token = String(data).trim();
        },
        language(state, data) {
            state.ui.window.language = String(data).trim().toLowerCase();
        },
        theme(state, data) {
            state.ui.window.theme = String(data).trim().toLowerCase();
        },
        user(state, data) {
            state.user = data;
        },
        settings(state, data) {
            state.settings = data;
        },
        translations(state, data) {
            state.ui.translations = data;
        },
        app_loaded(state, data) {
            state.ui.window.loaded = Boolean(data.loaded);
            state.ui.window.error = Boolean(data.error);
        }
    },
    actions: {
        http_get_settings(context) {
            return new Promise((resolve, reject) => {
                try {
                    Vue.http.get(context.state.settings.url.api + '/settings').then(resp => {
                        if (!Utils.isValidJSON(resp.bodyText)) {
                            return reject(false);
                        }
                        context.commit("settings", resp.body);
                        return resolve(true);
                    }, resp => {
                        console.error(resp);
                        return reject(false);
                    });
                } catch (error) {
                    return reject(false);
                }
            });
        },
        http_get_translations(context) {
            return new Promise((resolve, reject) => {
                try {
                    Vue.http.get(context.state.settings.url.api + '/translations/' + context.state.ui.window.language).then(resp => {
                        if (!Utils.isValidJSON(resp.bodyText)) {
                            return reject(false);
                        }
                        context.commit("translations", resp.body);
                        return resolve(true);
                    }, resp => {
                        console.error(resp);
                        return reject(false);
                    });
                } catch (error) {
                    return reject(false);
                }
            });
        },
        http_get_user_data(context, request_data) {
            return new Promise((resolve, reject) => {
                try {
                    const token = String(request_data.token).trim();
                    Vue.http.get(context.state.settings.url.api + '/user', { headers: { 'authorization': token } }).then(resp => {
                        if (!Utils.isValidJSON(resp.bodyText)) {
                            return reject(false);
                        }
                        resp.body.token = token;
                        context.commit("user", resp.body);
                        context.commit("language", resp.body.lang);
                        context.commit("theme", resp.body.theme);
                        return resolve(true);
                    }, resp => {
                        console.error(resp);
                        return reject(false);
                    });
                } catch (error) {
                    return reject(false);
                }
            });
        },
        http_update_theme(context, request_data) {
            return new Promise((resolve, reject) => {
                try {
                    Vue.http.post(context.state.settings.url.api + '/user/theme', { theme: String(request_data.theme).trim().toLowerCase() }, { headers: { 'authorization': context.state.user.token } }).then(resp => {
                        if (!Utils.isValidJSON(resp.bodyText)) {
                            return reject(false);
                        }
                        context.commit("theme", resp.body.theme);
                        return resolve(resp.body);
                    }, resp => {
                        console.error(resp);
                        return reject(false);
                    });
                } catch (error) {
                    return reject(false);
                }
            });
        },
        http_update_lang(context, request_data) {
            return new Promise((resolve, reject) => {
                try {
                    Vue.http.post(context.state.settings.url.api + '/user/lang', { lang: String(request_data.lang).trim().toLowerCase() }, { headers: { 'authorization': context.state.user.token } }).then(resp => {
                        if (!Utils.isValidJSON(resp.bodyText)) {
                            return reject(false);
                        }
                        context.commit("language", resp.body.lang);
                        return resolve(resp.body);
                    }, resp => {
                        console.error(resp);
                        return reject(false);
                    });
                } catch (error) {
                    return reject(false);
                }
            });
        },
        http_get_courses(context, request_data) {
            return new Promise((resolve, reject) => {
                try {
                    let request_query = (typeof request_data === 'undefined') ? "" : "?" + querystring.stringify(request_data);
                    Vue.http.get(context.state.settings.url.api + '/courses/' + request_query, { headers: { 'authorization': context.state.user.token } }).then(resp => {
                        if (!Utils.isValidJSON(resp.bodyText)) {
                            return reject(false);
                        }
                        return resolve(resp.body);
                    }, resp => {
                        console.error(resp);
                        return reject(false);
                    });
                } catch (error) {
                    return reject(false);
                }
            });
        },
        http_get_students(context, request_data) {
            return new Promise((resolve, reject) => {
                try {
                    let request_query = (typeof request_data === 'undefined') ? "" : "?" + querystring.stringify(request_data);
                    Vue.http.get(context.state.settings.url.api + '/user/students/' + request_query, { headers: { 'authorization': context.state.user.token } }).then(resp => {
                        if (!Utils.isValidJSON(resp.bodyText)) {
                            return reject(false);
                        }
                        return resolve(resp.body);
                    }, resp => {
                        console.error(resp);
                        return reject(false);
                    });
                } catch (error) {
                    return reject(false);
                }
            });
        },
        http_get_teachers(context, request_data) {
            return new Promise((resolve, reject) => {
                try {
                    let request_query = (typeof request_data === 'undefined') ? "" : "?" + querystring.stringify(request_data);
                    Vue.http.get(context.state.settings.url.api + '/user/teachers/' + request_query, { headers: { 'authorization': context.state.user.token } }).then(resp => {
                        if (!Utils.isValidJSON(resp.bodyText)) {
                            return reject(false);
                        }
                        return resolve(resp.body);
                    }, resp => {
                        console.error(resp);
                        return reject(false);
                    });
                } catch (error) {
                    return reject(false);
                }
            });
        },
        http_put_thesis_add_courses(context, request_data) {
            return new Promise((resolve, reject) => {
                try {
                    Vue.http.put(context.state.settings.url.api + '/thesis/addcourses/' + request_data.id, { courses: request_data.courses }, { headers: { 'authorization': context.state.user.token } }).then(resp => {
                        if (!Utils.isValidJSON(resp.bodyText)) {
                            return reject(false);
                        }
                        return resolve(resp.body);
                    }, resp => {
                        console.error(resp);
                        return reject(false);
                    });
                } catch (error) {
                    return reject(false);
                }
            });
        },
        http_put_thesis_add_students(context, request_data) {
            return new Promise((resolve, reject) => {
                try {
                    Vue.http.put(context.state.settings.url.api + '/thesis/addstudents/' + request_data.id, { students: request_data.students }, { headers: { 'authorization': context.state.user.token } }).then(resp => {
                        if (!Utils.isValidJSON(resp.bodyText)) {
                            return reject(false);
                        }
                        return resolve(resp.body);
                    }, resp => {
                        console.error(resp);
                        return reject(resp);
                    });
                } catch (error) {
                    return reject(false);
                }
            });
        },
        http_put_thesis_add_teachers(context, request_data) {
            return new Promise((resolve, reject) => {
                try {
                    Vue.http.put(context.state.settings.url.api + '/thesis/addteachers/' + request_data.id, { teachers: request_data.teachers }, { headers: { 'authorization': context.state.user.token } }).then(resp => {
                        if (!Utils.isValidJSON(resp.bodyText)) {
                            return reject(false);
                        }
                        return resolve(resp.body);
                    }, resp => {
                        console.error(resp);
                        return reject(false);
                    });
                } catch (error) {
                    return reject(false);
                }
            });
        },
        http_get_theses(context, request_data) {
            return new Promise((resolve, reject) => {
                try {
                    let request_query = (typeof request_data === 'undefined') ? "" : "?" + querystring.stringify(request_data);
                    Vue.http.get(context.state.settings.url.api + '/theses/' + request_query, { headers: { 'authorization': context.state.user.token } }).then(resp => {
                        if (!Utils.isValidJSON(resp.bodyText)) {
                            return reject(false);
                        }
                        return resolve(resp.body);
                    }, resp => {
                        console.error(resp);
                        return reject(false);
                    });
                } catch (error) {
                    return reject(false);
                }
            });
        },
        http_get_thesis(context, request_data) {
            return new Promise((resolve, reject) => {
                try {
                    Vue.http.get(context.state.settings.url.api + '/thesis/' + parseInt(request_data.id), { headers: { 'authorization': context.state.user.token } }).then(resp => {
                        if (!Utils.isValidJSON(resp.bodyText)) {
                            return reject(false);
                        }
                        return resolve(resp.body);
                    }, resp => {
                        console.error(resp);
                        return reject(false);
                    });
                } catch (error) {
                    return reject(false);
                }
            });
        },
        http_post_thesis(context, request_data) {
            return new Promise((resolve, reject) => {
                let req = {
                    titleEl: String(request_data.titleEl).trim(),
                    titleEn: String(request_data.titleEn).trim(),
                    abstractEl: String(request_data.abstractEl).trim(),
                    abstractEn: String(request_data.abstractEn).trim(),
                    howManyStudentsAllow: String(request_data.howManyStudentsAllow).trim(),
                    typeofthesis: String(request_data.typeofthesis).trim()
                };
                try {
                    Vue.http.post(context.state.settings.url.api + '/thesis', req, { headers: { 'authorization': context.state.user.token } }).then(resp => {
                        if (!Utils.isValidJSON(resp.bodyText)) {
                            return reject(false);
                        }
                        return resolve(resp.body);
                    }, resp => {
                        console.error(resp);
                        return reject(false);
                    });
                } catch (error) {
                    return reject(false);
                }
            });
        },
        http_put_thesis(context, request_data) {
            return new Promise((resolve, reject) => {
                let req = {
                    titleEl: String(request_data.titleEl).trim(),
                    titleEn: String(request_data.titleEn).trim(),
                    abstractEl: String(request_data.abstractEl).trim(),
                    abstractEn: String(request_data.abstractEn).trim(),
                    howManyStudentsAllow: String(request_data.howManyStudentsAllow).trim(),
                    typeofthesis: String(request_data.typeofthesis).trim()
                };
                try {
                    Vue.http.put(context.state.settings.url.api + '/thesis/' + parseInt(request_data.id), req, { headers: { 'authorization': context.state.user.token } }).then(resp => {
                        if (!Utils.isValidJSON(resp.bodyText)) {
                            return reject(false);
                        }
                        return resolve(resp.body);
                    }, resp => {
                        console.error(resp);
                        return reject(false);
                    });
                } catch (error) {
                    return reject(false);
                }
            });
        },
        http_delete_thesis(context, request_data) {
            return new Promise((resolve, reject) => {
                try {
                    Vue.http.delete(context.state.settings.url.api + '/thesis/' + parseInt(request_data.id), { headers: { 'authorization': context.state.user.token } }).then(resp => {
                        if (!Utils.isValidJSON(resp.bodyText)) {
                            return reject(false);
                        }
                        return resolve(resp.body);
                    }, resp => {
                        console.error(resp);
                        return reject(false);
                    });
                } catch (error) {
                    return reject(false);
                }
            });
        },
        http_get_notifications(context, request_data) {
            return new Promise((resolve, reject) => {
                try {
                    let request_query = (typeof request_data === 'undefined') ? "" : "?" + querystring.stringify(request_data);
                    Vue.http.get(context.state.settings.url.api + '/notifications/' + request_query, { headers: { 'authorization': context.state.user.token } }).then(resp => {
                        if (!Utils.isValidJSON(resp.bodyText)) {
                            return reject(false);
                        }
                        return resolve(resp.body);
                    }, resp => {
                        console.error(resp);
                        return reject(false);
                    });
                } catch (error) {
                    return reject(false);
                }
            });
        },
        http_get_notification(context, request_data) {
            return new Promise((resolve, reject) => {
                try {
                    Vue.http.get(context.state.settings.url.api + '/notification/' + parseInt(request_data.id), { headers: { 'authorization': context.state.user.token } }).then(resp => {
                        if (!Utils.isValidJSON(resp.bodyText)) {
                            return reject(false);
                        }
                        return resolve(resp.body);
                    }, resp => {
                        console.error(resp);
                        return reject(false);
                    });
                } catch (error) {
                    return reject(false);
                }
            });
        },
        http_delete_notification(context, request_data) {
            return new Promise((resolve, reject) => {
                try {
                    Vue.http.delete(context.state.settings.url.api + '/notification/' + parseInt(request_data.id), { headers: { 'authorization': context.state.user.token } }).then(resp => {
                        if (!Utils.isValidJSON(resp.bodyText)) {
                            return reject(false);
                        }
                        return resolve(resp.body);
                    }, resp => {
                        console.error(resp);
                        return reject(false);
                    });
                } catch (error) {
                    return reject(false);
                }
            });
        },
        http_get_schedules(context, request_data) {
            return new Promise((resolve, reject) => {
                try {
                    Vue.http.get(context.state.settings.url.api + '/schedule/' + parseInt(request_data.period), { headers: { 'authorization': context.state.user.token } }).then(resp => {
                        if (!Utils.isValidJSON(resp.bodyText)) {
                            return reject(false);
                        }
                        return resolve(resp.body);
                    }, resp => {
                        console.error(resp);
                        return reject(false);
                    });
                } catch (error) {
                    return reject(false);
                }
            });
        },
        http_add_thesis_to_schedule_period(context, request_data) {
            return new Promise((resolve, reject) => {
                try {
                    Vue.http.post(context.state.settings.url.api + '/schedule', { thesisid: String(request_data.thesisid).trim().toLowerCase(), period: String(request_data.period).trim().toLowerCase() }, { headers: { 'authorization': context.state.user.token } }).then(resp => {
                        if (!Utils.isValidJSON(resp.bodyText)) {
                            return reject(false);
                        }
                        return resolve(resp.body);
                    }, resp => {
                        console.error(resp);
                        return reject(resp);
                    });
                } catch (error) {
                    return reject(false);
                }
            });
        },
        http_finalize_schedule_of_period(context, request_data) {
            return new Promise((resolve, reject) => {
                try {
                    Vue.http.post(context.state.settings.url.api + '/schedulefinalize', { period: request_data.period }, { headers: { 'authorization': context.state.user.token } }).then(resp => {
                        if (!Utils.isValidJSON(resp.bodyText)) {
                            return reject(false);
                        }
                        return resolve(resp.body);
                    }, resp => {
                        console.error(resp);
                        return reject(resp);
                    });
                } catch (error) {
                    return reject(false);
                }
            });
        },
        http_update_schedule(context, request_data) {
            return new Promise((resolve, reject) => {
                try {
                    Vue.http.put(context.state.settings.url.api + '/schedule', { scheduleid: String(request_data.scheduleId), timepickerSchedule: String(request_data.timepickerSchedule), datepickerSchedule: String(request_data.datepickerSchedule), period: String(request_data.period).trim().toLowerCase() }, { headers: { 'authorization': context.state.user.token } }).then(resp => {
                        if (!Utils.isValidJSON(resp.bodyText)) {
                            return reject(false);
                        }
                        return resolve(resp.body);
                    }, resp => {
                        console.error(resp);
                        return reject(false);
                    });
                } catch (error) {
                    return reject(false);
                }
            });
        },
        http_remove_from_schedule(context, request_data) {
            return new Promise((resolve, reject) => {
                try {
                    Vue.http.delete(context.state.settings.url.api + '/schedule', { body: { scheduleid: String(request_data.scheduleid).trim().toLowerCase(), period: String(request_data.period).trim().toLowerCase() }, headers: { 'authorization': context.state.user.token } }).then(resp => {
                        if (!Utils.isValidJSON(resp.bodyText)) {
                            return reject(false);
                        }
                        return resolve(resp.body);
                    }, resp => {
                        console.error(resp);
                        return reject(false);
                    });
                } catch (error) {
                    return reject(false);
                }
            });
        },
        http_get_schedule_periods(context) {
            return new Promise((resolve, reject) => {
                try {
                    Vue.http.get(context.state.settings.url.api + '/period', { headers: { 'authorization': context.state.user.token } }).then(resp => {
                        if (!Utils.isValidJSON(resp.bodyText)) {
                            return reject(false);
                        }
                        return resolve(resp.body);
                    }, resp => {
                        console.error(resp);
                        return reject(false);
                    });
                } catch (error) {
                    return reject(false);
                }
            });
        },
        http_add_new_period_to_schedule(context) {
            return new Promise((resolve, reject) => {
                try {
                    Vue.http.post(context.state.settings.url.api + '/period', {}, { headers: { 'authorization': context.state.user.token } }).then(resp => {
                        if (!Utils.isValidJSON(resp.bodyText)) {
                            return reject(false);
                        }
                        return resolve(resp.body);
                    }, resp => {
                        console.error(resp);
                        return reject(false);
                    });
                } catch (error) {
                    return reject(false);
                }
            });
        },
        http_change_title_of_schedule_period(context, request_data) {
            return new Promise((resolve, reject) => {
                try {
                    Vue.http.put(context.state.settings.url.api + '/periodtitle', { period: String(request_data.period).trim().toLowerCase(), title: String(request_data.title).trim() }, { headers: { 'authorization': context.state.user.token } }).then(resp => {
                        if (!Utils.isValidJSON(resp.bodyText)) {
                            return reject(false);
                        }
                        return resolve(resp.body);
                    }, resp => {
                        console.error(resp);
                        return reject(false);
                    });
                } catch (error) {
                    return reject(false);
                }
            });
        },
        http_backlogin(context, request_data) {
            return new Promise((resolve, reject) => {
                try {
                    Vue.http.post(context.state.settings.url.api + '/login', { email: String(request_data.username).trim(), password: String(request_data.password).trim() }, { headers: {} }).then(resp => {
                        if (!Utils.isValidJSON(resp.bodyText)) {
                            return reject(false);
                        }
                        return resolve(resp.body);
                    }, resp => {
                        console.error(resp);
                        return reject(false);
                    });
                } catch (error) {
                    return reject(false);
                }
            });
        },
        http_send_thesis_file(context, request_data) {
            return new Promise((resolve, reject) => {
                try {
                    Vue.http.post(context.state.settings.url.api + '/uploadthesisfile', request_data.formData, { headers: { 'authorization': context.state.user.token, 'Content-Type': 'multipart/form-data' } }).then(resp => {
                        if (!Utils.isValidJSON(resp.bodyText)) {
                            return reject(false);
                        }
                        return resolve(resp.body);
                    }, resp => {
                        console.error(resp);
                        return reject(false);
                    });
                } catch (error) {
                    return reject(false);
                }
            });
        },
        http_send_thesis_file_proposal(context, request_data) {
            return new Promise((resolve, reject) => {
                try {
                    Vue.http.post(context.state.settings.url.api + '/uploadthesisfileproposal', request_data.formData, { headers: { 'authorization': context.state.user.token, 'Content-Type': 'multipart/form-data' } }).then(resp => {
                        if (!Utils.isValidJSON(resp.bodyText)) {
                            return reject(false);
                        }
                        return resolve(resp.body);
                    }, resp => {
                        console.error(resp);
                        return reject(false);
                    });
                } catch (error) {
                    return reject(false);
                }
            });
        },
        http_unlock_file_thesis(context, request_data) {
            return new Promise((resolve, reject) => {
                try {
                    Vue.http.post(context.state.settings.url.api + '/unlockfilethesis', { thesisid: request_data.thesisid, lockoption: request_data.lockoption }, { headers: { 'authorization': context.state.user.token } }).then(resp => {
                        if (!Utils.isValidJSON(resp.bodyText)) {
                            return reject(false);
                        }
                        return resolve(resp.body);
                    }, resp => {
                        console.error(resp);
                        return reject(false);
                    });
                } catch (error) {
                    return reject(false);
                }
            });
        },
        http_download_thesis(context, request_data) {
            axios.get(context.state.settings.url.api + "/downloadthesisfile/" + request_data.thesisid, {
                    responseType: 'arraybuffer',
                    headers: {
                        'authorization': context.state.user.token,
                        'Content-Type': 'application/json',
                        'Accept': 'application/pdf'
                    }
                })
                .then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', request_data.file);
                    if (typeof link.download === 'undefined') {
                        link.setAttribute('target', '_blank');
                    }
                    document.body.appendChild(link);
                    link.click();
                })
                .catch((error) => console.log(error));
        },
        http_download_thesis_proposal(context, request_data) {
            axios.get(context.state.settings.url.api + "/downloadthesisfileproposal/" + request_data.thesisid, {
                    responseType: 'arraybuffer',
                    headers: {
                        'authorization': context.state.user.token,
                        'Content-Type': 'application/json',
                        'Accept': 'application/pdf'
                    }
                })
                .then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', request_data.file);
                    if (typeof link.download === 'undefined') {
                        link.setAttribute('target', '_blank');
                    }
                    document.body.appendChild(link);
                    link.click();
                })
                .catch((error) => console.log(error));
        },
        http_send_response_for_exam_approval(context, request_data) {
            return new Promise((resolve, reject) => {
                try {
                    Vue.http.get(context.state.settings.url.api + '/requestapprovalforexam/' + request_data.thesisid, { headers: { 'authorization': context.state.user.token } }).then(resp => {
                        if (!Utils.isValidJSON(resp.bodyText)) {
                            return reject(false);
                        }
                        return resolve(resp.body);
                    }, resp => {
                        console.error(resp);
                        return reject(resp);
                    });
                } catch (error) {
                    return reject(false);
                }
            });
        },
        http_approve_thesis_for_exam(context, request_data) {
            return new Promise((resolve, reject) => {
                try {
                    Vue.http.post(context.state.settings.url.api + '/approvethesisforexam', { thesisid: request_data.thesisid, approveoption: request_data.approveoption }, { headers: { 'authorization': context.state.user.token } }).then(resp => {
                        if (!Utils.isValidJSON(resp.bodyText)) {
                            return reject(false);
                        }
                        return resolve(resp.body);
                    }, resp => {
                        console.error(resp);
                        return reject(resp);
                    });
                } catch (error) {
                    return reject(false);
                }
            });
        },
        http_get_grades(context, request_data) {
            return new Promise((resolve, reject) => {
                try {
                    Vue.http.get(context.state.settings.url.api + '/grade/' + parseInt(request_data.id), { headers: { 'authorization': context.state.user.token } }).then(resp => {
                        if (!Utils.isValidJSON(resp.bodyText)) {
                            return reject(false);
                        }
                        return resolve(resp.body);
                    }, resp => {
                        console.error(resp);
                        return reject(false);
                    });
                } catch (error) {
                    return reject(false);
                }
            });
        },
        http_save_grades(context, request_data) {
            return new Promise((resolve, reject) => {
                try {
                    Vue.http.post(context.state.settings.url.api + '/savegrades/' + request_data.fin, request_data.data, { headers: { 'authorization': context.state.user.token } }).then(resp => {
                        if (!Utils.isValidJSON(resp.bodyText)) {
                            return reject(false);
                        }
                        return resolve(resp.body);
                    }, resp => {
                        console.error(resp);
                        return reject(resp);
                    });
                } catch (error) {
                    return reject(error);
                }
            });
        },
        http_get_stats(context) {
            return new Promise((resolve, reject) => {
                try {                    
                    Vue.http.get(context.state.settings.url.api + '/stats', { headers: { 'authorization': context.state.user.token } }).then(resp => {
                        if (!Utils.isValidJSON(resp.bodyText)) {
                            return reject(false);
                        }
                        return resolve(resp.body);
                    }, resp => {
                        console.error(resp);
                        return reject(false);
                    });
                } catch (error) {
                    return reject(false);
                }
            });
        },
    }
});

export default store;